module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "d-case"
  }, [_c('img', {
    staticClass: "top-img",
    attrs: {
      "src": require("assets/case/02/img1.png")
    }
  }), _vm._m(0), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.scrollTop),
      expression: "scrollTop"
    }],
    staticClass: "scroll-top-btn",
    attrs: {
      "src": require("assets/goTop.png")
    },
    on: {
      "click": _vm.backtop
    }
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "case-num"
  }, [_vm._v("Vol.02")]), _c('div', {
    staticClass: "case-title"
  }, [_vm._v("上海246㎡精装大平层，用家具与配饰沉淀出家的味道")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("上海浦东陆家嘴某楼盘。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("金秋的空气中夹着桂花香，穿过一条两旁都是高大乔木的绿荫道，公寓楼前服务生把我们迎进门内。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("今天窝仔要去探访客户Bingxin的家。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/02/img2.png")
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("关于屋主")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("Bingxin和先生都是企业高管，两人相识并成家于德国，目前定居上海。家里还有一个可爱的混血宝贝Liam。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("从德国到上海，总共搬过3次家。家里很多装饰都辗转陪伴多年，与懂窝的家具相融，充满了家的味道。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/02/img3.png")
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("客餐厅：坐拥三面环景")]), _c('div', {
    staticClass: "line1"
  }, [_c('span', [_vm._v("坐标：上海浦东")]), _vm._v(" "), _c('span', [_vm._v("面积：246㎡")]), _vm._v(" "), _c('span', [_vm._v("户型：四室两厅")]), _vm._v(" "), _c('span', [_vm._v("风格：现代简约")]), _vm._v(" "), _c('span', [_vm._v("原始状态：精装修")])]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("站在Bingxin家客餐厅的窗前，可以看到被绿意环绕的小区周边，再往远眺，则是上海陆家嘴的繁华景象。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/02/img4.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("在这样一个寸土寸金的位置，空间即意味着奢侈。Bingxin家有3个卧室，1个保姆房，1个大阳台，还有让人兴奋的一体式客餐厅。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/02/img5.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("德国的家是简约通体的白，上海的家，也希望在相对简洁的框架下，打造出满足一家人生活需求的居住与休闲空间，同时兼备必要的收纳与展示功能。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("与懂窝结缘始于被产品所吸引，设计感强，简约耐看，非常符合她和先生西化的审美。与懂窝设计师深入沟通之后，更加让她笃定携手懂窝改造新家。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/02/img6.png")
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("客餐厅，不一定要有电视")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("客餐厅占据了Bingxin家最大的面积，足有50㎡，连成长条，直通厨房。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/02/img7.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("设计的时候就考虑不要电视，一来怕影响孩子，二来，用书和音乐装点客厅，可以让家庭氛围更有质感。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("这里是一家人活动最频繁的区域。设计师为它定义了5个功能：沙发区、餐厅、书柜、展示陈列、儿童玩乐区。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/02/img8.png")
    }
  }), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/02/img9.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("房子原先的墙面是灰色的，Bingxin比较喜欢灰蓝带来的沉郁格调，于是率性重新刷了色。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/02/img10.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("没有选择转角沙发，而用两张三人位沙发替代，“这样可以容纳更多人，两个人可以躺在不同沙发上，互不打扰”。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/02/img11.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("懂窝的巴罗沙发，外形极简大方，高弹靠背坐感舒适，宽大的包裹感，刚好符合Bingxin的需求。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("拉里亚落地灯 摆在了两个沙发之间，偏工业风的设计，与整体气质并不违和，晚上躺在沙发上，可以在光源的映衬下看看书。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/02/img12.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("两把休闲椅与沙发呈围合之势，同样是素雅的米色，带有一定倾斜度的坐感非常舒适。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/02/img13.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("椅上点缀懂窝奥萨卡波西米亚风抱枕，精致的刺绣与色彩既抢眼又耐看。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/02/img14.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("一张几何形状的凯斯勒地毯，丰富跳跃的色彩，掩盖颜色略深的地板，让沙发区温暖而不沉闷。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/02/img15.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("黑色的圆形小边几，充满设计感的外形像是一件装饰，同时可以满足简单的置物需求。一个黄铜双层托盘，随手收纳桌面小物，很实用。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/02/img16.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("米色的B&O音响安静置于角落，待孩子睡下，坐在沙发边放上一段音乐，让身心放空，是Bingxin最轻松的时刻。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/02/img17.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("客厅边上，在设计师建议下做了一排米色的收纳柜，充当书架与展示区。这也是非常节省空间的做法，让客厅功能更多元，闲来无事，可以随手抽出一本书翻阅。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/02/img18.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("客厅及餐厅区域，单独辟开两块位置给到1岁半的儿子Liam，成为小家伙的玩乐空间。一个金属内框、实木面的矮柜，既可用来放小朋友的玩具，还可以当长凳。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/02/img19.png")
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("用艺术画作装饰家")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("Bingxin和先生都很喜欢画，家里的墙面展示了不少两人收藏的画作。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("推门进入玄关，映入眼帘是一幅热闹的山景，浓烈的橙黄，让人感受到家的温馨。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/02/img20.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("客厅尽头一幅相对大尺寸的画，是Bingxin出差时在广州一家画廊买的，当时看到觉得很触动，花了很贵的价钱买下。近看像是明黄与墨绿两种色彩的堆叠，远观，是一匹马的形象。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/02/img21.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("边柜上的黑白画作，选自懂窝，像花开至荼蘼，有一种凄冷的美。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/02/img22.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("家里的画大多跟随Bingxin一家多年，更迭迁徙，也没有刻意迎合现有的家居布置，却又非常映衬。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/02/img23.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("卧室延续了客厅的灰蓝色墙面，是更加让人安静的空间。竹编的窗帘，既通透又能确保隐私。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/02/img24.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("懂窝的绿色丝绒床，优雅的丝绒像藏着时间的故事，复古，精致，在灰蓝色的映衬下，更加彰显宁静的气场。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/02/img25.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("床头挂画的复古绿意与丝绒床呼应，气质神秘。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/02/img26.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("几张皮毛地毯，铺垫在床边，让脚感更加舒适，也增添了卧室的温暖氛围。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/02/img27.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("几个色彩斑斓的泥罐，是孟加拉的同事送给他们的礼物，点缀在角落里非常讨喜。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/02/img28.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("与卧室相连的是一个大阳台，天气好的时候可以看书赏景，月下小酌，是提升生活质量的一个必不可少的空间。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/02/img29.png")
    }
  }), _c('div', {
    staticClass: "cont-title"
  }, [_vm._v("用久了的器物，会有家的味道")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("从德国到上海，Bingxin搬了3次家。虽然每次都是新家，却没有太多陌生感。因为这里填充的，很多都是用了很多年的器物。")]), _c('div', {
    staticClass: "line1"
  }, [_vm._v("要论最喜欢的，还是客厅的边柜上方，一个花纹复古的漆器摆饰，来自Bingxin家乡重庆的匠工细意雕琢，精致感十足。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/02/img30.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("餐厅与客厅之间以一张懂窝电视柜作为区隔。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/02/img31.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("费尔贝恩餐边柜，胡桃木饰面花纹流畅，与电视柜及木地板颜色迎合，气息沉静优雅。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/02/img32.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("一张实木餐桌，是从德国的家空运来的，木料厚重敦实，桌面有油渍、划痕，带着过往生活的印记，触目很亲切。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/02/img33.png")
    }
  }), _c('div', {
    staticClass: "line1"
  }, [_vm._v("这些用久了的器物，带着家的气息，穿越尘嚣，沉淀出家的味道。而总有一天，选自懂窝的家具，也会融入其中，成为家的一部分。")]), _c('img', {
    staticClass: "cont-img",
    attrs: {
      "src": require("assets/case/02/img34.png")
    }
  }), _c('div', {
    staticClass: "cont-title1"
  }, [_vm._v(" Q&A")]), _c('div', {
    staticClass: "line2"
  }, [_c('span', [_vm._v("Q：为什么选择懂窝的家具？")]), _vm._v("在懂窝展厅看到，家具非常简约有设计感，我们在德国的家也是通体的白色，家具也非常简约。这样的风格比较符合我们的审美。")]), _c('div', {
    staticClass: "line2"
  }, [_c('span', [_vm._v("Q：您最喜欢懂窝的哪件家具？")]), _vm._v("最喜欢客厅的沙发，很好看，坐感也非常舒服。大的靠包软软的，长度也可以满足我们两个人分别躺卧。")]), _c('div', {
    staticClass: "line2"
  }, [_c('span', [_vm._v("Q：看到您家很多装饰品，在软饰搭配这块您有什么心得？")]), _vm._v("从整体色彩上，我比较喜欢灰蓝的沉静感，可以让人心情很安静。这些挂画基本都是我们旅途中买的，比如床头那，带有一点绿色觉得和绿色丝绒床很搭，摆上去刚好也合适。还是看感觉搭配吧。")]), _c('div', {
    staticClass: "line2"
  }, [_c('span', [_vm._v("Q：整个房子改造花费多少？")]), _vm._v("懂窝产品性价比很高，客餐厅还有卧室区域基本是在懂窝买的家具，总共5万多吧。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ff5b7ec"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/case2.vue
// module id = 442
// module chunks = 0